import { styled } from '@mui/material'

export const Footer = styled('footer')(() => ({
  padding: '24px 32px 16px',
  width: '100%',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
}))
